import { Action } from '@ngrx/store';
import { AlertMessageInterface } from '../../models/alert-message.interface';

export enum EAlertMessageActions {
  GetAlertMessage = '[ALERT] Alert message'
}

export class GetAlertMessage implements Action {
  public readonly type = EAlertMessageActions.GetAlertMessage;
  constructor(public payload: AlertMessageInterface) {}
}

export type AlertMessageActions = GetAlertMessage;
